import React from 'react';
const Error = () => {
    return ( 
        <div>
            <h1>Sorry, but This Link Does Not Exist</h1>
        </div>
     );
}
 
export default Error;